import TutorialIndexData from "./TutorialIndexSummary";

export default class TutorialContentSummary
{
   
    constructor(tutorialIndexes,tutorialSections)
    {
        this.TutorialIndexes=tutorialIndexes?[]:tutorialIndexes;
        this.TutorialSection =tutorialSections?[]:tutorialSections;


    }
    
    /** @type{number} */
    TutorialId;


     /** @type{string} */
    Title;

    /**@type{string} */
    Slug;

    /** @type{string} */
    Icon;
    

    /** @type {TutorialSection[]} */
    TutorialSections =[];

    /** @type {TutorialIndexSummary[]} */
    TutorialIndexes=[];

}